module.exports = __webpack_public_path__ + "static/Symphonia7-09bbfa75fddf3d426352b55c24082a22.png";